var body = $("html, body");
function scrollToCustom(id, offset,callback){
    //console.log("scroll",offset)
    var scroll = TweenMax.to(body, 1.5, { scrollTop: $(id).parent(".scrollmagic-pin-spacer").offset().top + offset, ease: Power2.easeOut });
    scroll.eventCallback("onComplete", function(){
        if (typeof callback === "function") {
            callback();
        }
    });
}

var stack=[];
function transImage(idx){
    //console.log("transImage:",idx);
    let curObj=$(".scroll-animation-pic-video-text-section").find(".images-animate").find(".item").eq(idx);
    curObj.css("display","block");
    stack[idx] =  TweenMax.to(curObj[0],0.3,{opacity:1, ease: Power1.easeIn})
    //TweenMax.to(curObj.find(".video")[0],0.3,{opacity:1, ease: Power1.easeIn})

    let video=curObj.find("video");
    if(video.length>0){
        //video[0].load();
        video[0].addEventListener('loadeddata', function() {
            video[0].play();
        });
        video[0].addEventListener('ended', function() {
            video[0].currentTime=0;
        });
        video[0].play();
    }
    //if(idx!=0){
        
        let len=$(".scroll-animation-pic-video-text-section").find(".images-animate").find(".item").length;
        for(let i=0;i<len;i++){
            if(i==idx){
                continue;
            }
            if(i in stack){
                //console.log("pause:",i);
                stack[i].pause();
            }
            let lastObj=$(".scroll-animation-pic-video-text-section").find(".images-animate").find(".item").eq(i);
            TweenMax.to(lastObj[0],0,{opacity:0, display:'none'})
        }
        //TweenMax.to(lastObj.find(".video")[0],0,{opacity:0, ease: Power1.easeIn})
    //}
}

function initialOne(){
    let minorHeadingList=$(".scroll-animation-pic-video-text-section").find(".text-animate>.item").map((idx,obj)=>{
        var htmlObj = $(obj).clone();
        htmlObj.find(".heading").remove();
        // if(idx!=0){
        //     htmlObj.css("display","none");
        // }
        //console.log("htmlObj:",htmlObj[0].outerHTML)
        //return htmlObj[0].outerHTML;
        $(".scroll-animation-pic-video-text-section").find(".mobile-progress").find(".minor-heading-list").append(htmlObj[0].outerHTML);
    });

    let ctrlBtnItemLen=$(".scroll-animation-pic-video-text-section").find(".ctr-animate").find(".item").length;
    $(".scroll-animation-pic-video-text-section").find(".mobile-progress").find(".cur").text(1);
    $(".scroll-animation-pic-video-text-section").find(".mobile-progress").find(".total").text(ctrlBtnItemLen);
    //console.log("minorHeadingList:",minorHeadingList)
}

function calcHeight(){
    var calcH=function(){
        let maxHeight=0;
        $(".dynamic-height>div").each((idx,obj)=>{
            let height=$(obj).outerHeight();
            if(height>maxHeight){
                maxHeight=height;
            }
        });
        $(".dynamic-height").css("height",maxHeight+"px");
    }
    $(window).on("resize",function(){
        calcH();
    });
    calcH();
}

function scrollAnimationOne(){
    initialOne();

    let ctrlBtnHeight=$(".scroll-animation-pic-video-text-section").find(".scroll-animate").height();
    var g_duration=$(".scroll-animation-pic-video-text-section").height()*4;
    
    let ctrlBtnItemLen=$(".scroll-animation-pic-video-text-section").find(".ctr-animate").find(".item").length;
    let delayScale=0.03;
    let unitSize=ctrlBtnHeight/ctrlBtnItemLen;
    let curScrollHeight=0;
    var controller = new ScrollMagic.Controller();

    var timeline = new TimelineMax();

    TweenMax.set($(".scroll-animation-pic-video-text-section").find(".images-animate").find(".item").eq(0),{x:'20%', ease: "Linear.easeNone"});
    TweenMax.set($(".scroll-animation-pic-video-text-section").find(".images-animate").find(".item").eq(0).find(".video")[0],{opacity:0, ease: "Linear.easeNone"});
    TweenMax.set($(".scroll-animation-pic-video-text-section").find(".text-animate"),{y:unitSize, ease: Power1.easeIn});
    TweenMax.set($(".scroll-animation-pic-video-text-section").find(".text-animate").find(".item").eq(0),{y:-unitSize, ease: Power1.easeIn});

    TweenMax.set($(".scroll-animation-pic-video-text-section").find(".minor-heading-animate"),{y:unitSize, ease: Power1.easeIn});
    TweenMax.set($(".scroll-animation-pic-video-text-section").find(".minor-heading-animate").find(".item").eq(0),{ease: Power1.easeIn});

    timeline.add([
        TweenMax.to($(".scroll-animation-pic-video-text-section").find(".images-animate").find(".item").eq(0),0.02,{x:'0%', ease: "Linear.easeNone"}),
        TweenMax.to($(".scroll-animation-pic-video-text-section").find(".images-animate").find(".item").eq(0).find(".video")[0],0.02,{opacity:1, ease: "Linear.easeNone"}),
        TweenMax.to($(".scroll-animation-pic-video-text-section").find(".right"),0.025,{opacity:1, delay:0.01, ease: Linear.easeIn}),
        TweenMax.to($(".scroll-animation-pic-video-text-section").find(".ctr-animate"),0.01,{x:0,y:curScrollHeight, onUpdateParams:[0], ease: Power1.easeInOut}).eventCallback("onReverseComplete",function(e){
            //console.log("onRepeat1",e);
        },[0])
        .eventCallback("onUpdate",function(idx){
            //console.log("onUpdate1",idx);
            if(!$(".scroll-animation-pic-video-text-section").find(".ctr-animate").find(".item").eq(idx).hasClass("active")){
                $(".scroll-animation-pic-video-text-section").find(".ctr-animate").find(".item").eq(idx).addClass("active").siblings().removeClass("active");
                transImage(idx);
                $(".scroll-animation-pic-video-text-section").find(".mobile-progress").find(".cur").text(idx+1);
            }
        })
        .eventCallback("onEnter",function(idx){
            //console.log("ctr-animate onEnter",idx)
            transImage(idx);
            $(".scroll-animation-pic-video-text-section").find(".mobile-progress").find(".cur").text(idx+1);
        })
    ]).add([
        //TweenMax.to($(".scroll-animation-pic-video-text-section").find(".images-animate").find(".item").eq(0),0.02,{opacity:0, ease: Power1.easeIn}),
        TweenMax.to($(".scroll-animation-pic-video-text-section").find(".text-animate").find(".item").eq(0),0.02,{opacity:0, y:-unitSize*2, ease: Power1.easeIn}),
        TweenMax.to($(".scroll-animation-pic-video-text-section").find(".minor-heading-animate").find(".item").eq(0),0.02,{opacity:0, ease: Power1.easeIn}),
    ],0.03);

    for(let i=1;i<ctrlBtnItemLen;i++){
        curScrollHeight-=unitSize;
        delayScale+=0.02;
        timeline.add([
            TweenMax.to($(".scroll-animation-pic-video-text-section").find(".ctr-animate"),0.01,{x:0,y:curScrollHeight, onUpdateParams:[i], ease: Power1.easeInOut}).eventCallback("onReverseComplete",function(idx){
                //console.log("onRepeat2",idx);
                $(".scroll-animation-pic-video-text-section").find(".ctr-animate").find(".item").eq(idx).addClass("active").siblings().removeClass("active");
                transImage(idx);
                $(".scroll-animation-pic-video-text-section").find(".mobile-progress").find(".cur").text(idx+1);
            },[i-1])
            .eventCallback("onUpdate",function(idx){
                //console.log("onUpdate2",idx);
                if(!$(".scroll-animation-pic-video-text-section").find(".ctr-animate").find(".item").eq(idx).hasClass("active")){
                    $(".scroll-animation-pic-video-text-section").find(".ctr-animate").find(".item").eq(idx).addClass("active").siblings().removeClass("active");
                    transImage(idx);
                    $(".scroll-animation-pic-video-text-section").find(".mobile-progress").find(".cur").text(idx+1);
                }
            })
        ],delayScale);

        timeline.add([
            //TweenMax.to($(".scroll-animation-pic-video-text-section").find(".images-animate").find(".item").eq(i),0.02,{opacity:1, ease: Power1.easeIn}),
            TweenMax.to($(".scroll-animation-pic-video-text-section").find(".text-animate").find(".item").eq(i),0.02,{opacity:1,y:-unitSize, ease: Power1.easeIn}),
            TweenMax.to($(".scroll-animation-pic-video-text-section").find(".minor-heading-animate").find(".item").eq(i),0.02,{opacity:1, ease: Power1.easeIn}),
        ],delayScale)

        if(i+1!=ctrlBtnItemLen){
            delayScale+=0.04;
            timeline.add([
                //TweenMax.to($(".scroll-animation-pic-video-text-section").find(".images-animate").find(".item").eq(i),0.02,{opacity:0, ease: Power1.easeIn}),
                TweenMax.to($(".scroll-animation-pic-video-text-section").find(".text-animate").find(".item").eq(i),0.02,{opacity:0,y:-unitSize*2, ease: Power1.easeIn}),
                TweenMax.to($(".scroll-animation-pic-video-text-section").find(".minor-heading-animate").find(".item").eq(i),0.02,{opacity:0, ease: Power1.easeIn}),
            ],delayScale);
        }
    }

    var sectionScroll = new ScrollMagic.Scene({
        duration: g_duration,
        offset: 0,
        triggerElement: ".scroll-animation-pic-video-text-section",
        triggerHook: 0,
        reverse: true
    })
    .setPin(".scroll-animation-pic-video-text-section", {
        pushFollowers: true
    })
    .setTween(timeline)
    // .addIndicators()
    .addTo(controller);


    sectionScroll.on("enter", function (event) {
        //console.log("enter");
    });

    var lastFrameIdx=-1;
    sectionScroll.on("progress", function (event) {
        //console.log("progress",event);
        let firstFrame=0.13;
        let unitDuration=(1-firstFrame)/(ctrlBtnItemLen-1);
        let idx=Math.ceil((event.progress-firstFrame)/unitDuration);
        idx=idx<=0?0:idx;
        //console.log("unitDuration:",unitDuration,"idx:",idx, event.progress);
        if(event.scrollDirection=="FORWARD"){
            if(lastFrameIdx!=idx){
                lastFrameIdx=idx;
                
                // let curObj=$(".scroll-animation-pic-video-text-section").find(".images-animate").find(".item").eq(idx);
                // stack[idx] =  TweenMax.to(curObj[0],0.3,{opacity:1, ease: Power1.easeIn})
                // //TweenMax.to(curObj.find(".video")[0],0.3,{opacity:1, ease: Power1.easeIn})

                // let video=curObj.find("video");
                // if(video.length>0){
                //     video[0].load();
                //     video[0].addEventListener('loadeddata', function() {
                //         video[0].play();
                //     });
                //     video[0].addEventListener('ended', function() {
                //         video[0].currentTime=0;
                //     });
                // }
                // if(idx!=0){
                //     if(idx-1 in stack){
                //         stack[idx-1].pause();
                //     }
                //     let lastObj=$(".scroll-animation-pic-video-text-section").find(".images-animate").find(".item").eq(idx-1);
                //     TweenMax.to(lastObj[0],0,{opacity:0, ease: Power1.easeIn})
                //     //TweenMax.to(lastObj.find(".video")[0],0,{opacity:0, ease: Power1.easeIn})
                // }
            }
        }
        if(event.scrollDirection=="REVERSE"){
            if(lastFrameIdx != idx){
                lastFrameIdx=idx;
                
                // //console.log("REVERSE",idx, "lastFrameIdx:",lastFrameIdx);
                // let curObj=$(".scroll-animation-pic-video-text-section").find(".images-animate").find(".item").eq(idx);
                // stack[idx] =  TweenMax.to(curObj[0],0.3,{opacity:1, ease: Power1.easeIn})

                // //TweenMax.to(curObj.find(".video")[0],0.3,{opacity:1, ease: Power1.easeIn})

                // let video=curObj.find("video");
                // if(video.length>0){
                //     video[0].load();
                //     video[0].addEventListener('loadeddata', function() {
                //         video[0].play();
                //     });
                //     video[0].addEventListener('ended', function() {
                //         video[0].currentTime=0;
                //     });
                // }

                // if(idx+1!=ctrlBtnItemLen){
                //     if(idx+1 in stack){
                //         console.log("pause",idx+1)
                //         stack[idx+1].pause();
                //     }
                //     let lastObj=$(".scroll-animation-pic-video-text-section").find(".images-animate").find(".item").eq(idx+1);
                //     TweenMax.to(lastObj[0],0,{opacity:0, ease: Power1.easeIn})
                //     //TweenMax.to(lastObj.find(".video")[0],0,{opacity:0, ease: Power1.easeIn})
                // }
            }
        }
    });

    sectionScroll.on("leave", function (event) {
        //console.log("leave",event);
    });


    $(".scroll-animation-pic-video-text-section").find(".ctr-animate>.item").on("click",function(){
        let start=0.09;
        let offset=g_duration*start + $(this).index()*(g_duration*(1-start))/(ctrlBtnItemLen-1);
        //console.log("aaaa",$(this).index());
        scrollToCustom(".scroll-animation-pic-video-text-section",offset)
    });
}

var stack2=[];
function transImageTwo(idx){
    //console.log("transImage:",idx);
    var curObj=$(".scroll-animation-pic-text-section").find(".images-animate").find(".item").eq(idx);
    curObj.css("display","block");
    stack2[idx] =  TweenMax.to(curObj[0],0.3,{opacity:1, ease: Power1.easeIn})
    
    let video=curObj.find("video");
    if(video.length>0){
        //video[0].load();
        video[0].addEventListener('loadeddata', function() {
            video[0].play();
        });
        video[0].addEventListener('ended', function() {
            video[0].currentTime=0;
        });
        video[0].play();
    }

    let len=$(".scroll-animation-pic-text-section").find(".images-animate").find(".item").length;
    for(let i=0;i<len;i++){
        if(i==idx){
            continue;
        }
        if(i in stack2){
            //console.log("pause:",i);
            stack2[i].pause();
        }
        TweenMax.to($(".scroll-animation-pic-text-section").find(".images-animate").find(".item").eq(i)[0],0,{opacity:0, display:'none', ease: Power1.easeIn})
    }
}

function initialTwo(){
    let ctrlBtnItemLen=$(".scroll-animation-pic-text-section").find(".ctr-animate").find(".item").length;
    $(".scroll-animation-pic-text-section").find(".mobile-progress").find(".cur").text(1);
    $(".scroll-animation-pic-text-section").find(".mobile-progress").find(".total").text(ctrlBtnItemLen);
    //console.log("minorHeadingList:",minorHeadingList)
}

function scrollAnimationTwo(){
    initialTwo();
    let ctrlBtnHeight=$(".scroll-animation-pic-text-section").find(".scroll-animate").height();
    var g_duration=$(".scroll-animation-pic-text-section").height();
    
    let ctrlBtnItemLen=$(".scroll-animation-pic-text-section").find(".ctr-animate").find(".item").length;
    let delayScale=0.03;
    let unitSize=ctrlBtnHeight/ctrlBtnItemLen;
    let curScrollHeight=0;
    var controller = new ScrollMagic.Controller();

    var timeline = new TimelineMax();
    TweenMax.set($(".scroll-animation-pic-text-section").find(".text-animate"),{y:unitSize, ease: Power1.easeIn});
    TweenMax.set($(".scroll-animation-pic-text-section").find(".text-animate").find(".item").eq(0),{y:-unitSize, ease: Power1.easeIn});

    timeline.add([
        TweenMax.to($(".scroll-animation-pic-text-section").find(".ctr-animate"),0.01,{x:0,y:curScrollHeight, onUpdateParams:[0], ease: Power1.easeInOut}).eventCallback("onReverseComplete",function(e){
            //console.log("onRepeat1",e);
        },[0])
        .eventCallback("onUpdate",function(idx){
            //console.log("onUpdate1",idx);
            if(!$(".scroll-animation-pic-text-section").find(".ctr-animate").find(".item").eq(idx).hasClass("active")){
                $(".scroll-animation-pic-text-section").find(".ctr-animate").find(".item").eq(idx).addClass("active").siblings().removeClass("active");
                transImageTwo(idx);
                $(".scroll-animation-pic-text-section").find(".mobile-progress").find(".cur").text(idx+1);
            }
        })
    ]).add([
        //TweenMax.to($(".scroll-animation-pic-text-section").find(".images-animate").find(".item").eq(0),0.02,{opacity:0, ease: Power1.easeIn}),
        TweenMax.to($(".scroll-animation-pic-text-section").find(".text-animate").find(".item").eq(0),0.01,{opacity:0,y:-unitSize*2, ease: Power1.easeIn}),
    ],0.03);

    for(let i=1;i<ctrlBtnItemLen;i++){
        curScrollHeight-=unitSize;
        delayScale+=0.02;
        timeline.add([
            TweenMax.to($(".scroll-animation-pic-text-section").find(".ctr-animate"),0.01,{x:0,y:curScrollHeight, onUpdateParams:[i], ease: Power1.easeInOut}).eventCallback("onReverseComplete",function(idx){
                //console.log("onRepeat2",idx);
                $(".scroll-animation-pic-text-section").find(".ctr-animate").find(".item").eq(idx).addClass("active").siblings().removeClass("active");
                transImageTwo(idx);
                $(".scroll-animation-pic-text-section").find(".mobile-progress").find(".cur").text(idx+1);
            },[i-1])
            .eventCallback("onUpdate",function(idx){
                //console.log("onUpdate2",idx);
                if(!$(".scroll-animation-pic-text-section").find(".ctr-animate").find(".item").eq(idx).hasClass("active")){
                    $(".scroll-animation-pic-text-section").find(".ctr-animate").find(".item").eq(idx).addClass("active").siblings().removeClass("active");
                    transImageTwo(idx);
                    $(".scroll-animation-pic-text-section").find(".mobile-progress").find(".cur").text(idx+1);
                }
            })
        ],delayScale);

        timeline.add([
            //TweenMax.to($(".scroll-animation-pic-text-section").find(".images-animate").find(".item").eq(i),0.02,{opacity:1, ease: Power1.easeIn}),
            TweenMax.to($(".scroll-animation-pic-text-section").find(".text-animate").find(".item").eq(i),0.02,{opacity:1,y:-unitSize, ease: Power1.easeIn}),

            
        ],delayScale)

        if(i+1!=ctrlBtnItemLen){
            delayScale+=0.06;
            timeline.add([
                //TweenMax.to($(".scroll-animation-pic-text-section").find(".images-animate").find(".item").eq(i),0.02,{opacity:0, ease: Power1.easeIn}),
                TweenMax.to($(".scroll-animation-pic-text-section").find(".text-animate").find(".item").eq(i),0.01,{opacity:0,y:-unitSize*2, ease: Power1.easeIn}),
            ],delayScale);
        }
    }

    var sectionScroll = new ScrollMagic.Scene({
        duration: g_duration,
        offset: 0,
        triggerElement: ".scroll-animation-pic-text-section",
        triggerHook: 0,
        reverse: true
    })
    .setPin(".scroll-animation-pic-text-section", {
        pushFollowers: true
    })
    .setTween(timeline)
    // .addIndicators()
    .addTo(controller);


    sectionScroll.on("enter", function (event) {
        //console.log("enter");
        var curObj=$(".scroll-animation-pic-text-section").find(".images-animate").find(".item").eq(0);
        let video=curObj.find("video");
        if(video.length>0){
            //video[0].load();
            video[0].addEventListener('loadeddata', function() {
                video[0].play();
            });
            video[0].addEventListener('ended', function() {
                video[0].currentTime=0;
            });
            video[0].play();
        }
    });

    var lastFrameIdx=-1;
    var stack=[];
    sectionScroll.on("progress", function (event) {
        let firstFrame=0;
        let unitDuration=(1-firstFrame)/(ctrlBtnItemLen);
        let idx=Math.ceil((event.progress-firstFrame)/unitDuration)-1;
        idx=idx<=0?0:idx;
        //console.log("unitDuration:",unitDuration,"idx:",idx, event.progress);
        if(event.scrollDirection=="FORWARD"){
            if(lastFrameIdx!=idx){
                lastFrameIdx=idx;
                
                // var curObj=$(".scroll-animation-pic-text-section").find(".images-animate").find(".item").eq(idx);
                // stack[idx] =  TweenMax.to(curObj[0],0.3,{opacity:1, ease: Power1.easeIn})
                
                // let video=curObj.find("video");
                // if(video.length>0){
                //     video[0].load();
                //     video[0].addEventListener('loadeddata', function() {
                //         video[0].play();
                //     });
                //     video[0].addEventListener('ended', function() {
                //         video[0].currentTime=0;
                //     });
                // }

                // if(idx!=0){
                //     if(idx-1 in stack){
                //         stack[idx-1].pause();
                //     }
                //     TweenMax.to($(".scroll-animation-pic-text-section").find(".images-animate").find(".item").eq(idx-1)[0],0,{opacity:0, ease: Power1.easeIn})
                // }
            }
        }
        if(event.scrollDirection=="REVERSE"){
            if(lastFrameIdx != idx){
                lastFrameIdx=idx;
                
                //console.log("REVERSE",idx, "lastFrameIdx:",lastFrameIdx);
                // var curObj=$(".scroll-animation-pic-text-section").find(".images-animate").find(".item").eq(idx);

                // stack[idx] =  TweenMax.to(curObj[0],0.3,{opacity:1, ease: Power1.easeIn})

                // let video=curObj.find("video");
                // if(video.length>0){
                //     video[0].load();
                //     video[0].addEventListener('loadeddata', function() {
                //         video[0].play();
                //     });
                //     video[0].addEventListener('ended', function() {
                //         video[0].currentTime=0;
                //     });
                // }

                // if(idx+1!=ctrlBtnItemLen){
                //     if(idx+1 in stack){
                //         console.log("pause",idx+1)
                //         stack[idx+1].pause();
                //     }
                //     TweenMax.to($(".scroll-animation-pic-text-section").find(".images-animate").find(".item").eq(idx+1),0,{opacity:0, ease: Power1.easeIn})
                // }
            }
        }
    });

    sectionScroll.on("leave", function (event) {
       //console.log("leave",event);
    });

    $(".scroll-animation-pic-text-section").find(".ctr-animate>.item").on("click",function(){
        let offset=g_duration*0.1 + $(this).index()*(g_duration*0.9)/(ctrlBtnItemLen-1);
        //console.log("bbbb",$(this).index());
        scrollToCustom(".scroll-animation-pic-text-section",offset)
    });
}
$(function(){
    scrollAnimationOne();
    scrollAnimationTwo();
    calcHeight();
  
    yall({
      observeChanges: true
    });
});